export default "__VITE_ASSET__b3eda23f__"